import clsx from "clsx";

export type NewBusinessAvatarProps = {
  businessDisplayName: string;
  className?: string;
};

export function BusinessAvatar(props: NewBusinessAvatarProps) {
  return (
    <div
      className={clsx(
        "w-8 h-8 cursor-pointer aspect-square",
        "flex items-center justify-center",
        "text-white font-medium text-sm rounded-lg",
        props.className,
      )}
    >
      {props.businessDisplayName.charAt(0).toUpperCase()}
    </div>
  );
}
